<div class="newBillingData__cont">
  <app-ds-data-action-card
    [failedType]="dataActionFailedType.Warning"
    [info]="[
      {
        Type: dataActionCardInfoType.Action,
        Title: 'BOOKING_MODULE.BILLING.NEW_OPTION' | transloco,
        DataIcon: icons.AccountState,
        ActionIcon: icon,
        ActionIsFailed: showError
      }
    ]"
    (clickEvent)="clickEvent()">
  </app-ds-data-action-card>
</div>